import type { APIResponse } from './BaseProxy';
import APIBaseProxy from './BaseProxy';
import { DEFAULT_REQUEST_TIMEOUT } from './constants';

/**
 * 该类是基于 XHR 实现 http 请求的封装
 */
class XHRProxy extends APIBaseProxy {
  // xhr 对象
  private xhr: XMLHttpRequest = new XMLHttpRequest();
  // headers 对象
  private headers: { [key: string]: string } = {};

  // 发送请求的方法
  protected handleSendRequest(url: string) {
    this.xhr.timeout = this.config.timeout ?? DEFAULT_REQUEST_TIMEOUT;
    this.xhr.withCredentials = this.config.withCredentials;
    this.xhr.open(this.config.method, url, true);
    this.setHeaders();
    if (this.config.method === 'POST' || this.config.method === 'PUT') {
      const d = this.getPostData() as any;
      this.xhr.send(d);
    } else {
      this.xhr.send();
    }
    return new Promise<APIResponse>((ok) => {
      this.xhr.onreadystatechange = () => {
        if (
          this.config.method === 'HEAD'
          && this.xhr.readyState === this.xhr.DONE
        ) {
          return ok({ status: 200, data: {} });
        }
        if (this.xhr.readyState === 4) {
          if (this.xhr.status === 200) {
            const res = this.handleRes(
              'success',
              this.xhr.status,
              this.xhr.responseText
            );
            if (this.config.method === 'GET' && this.config.useCache) {
              this.cache.set(url, this.xhr.responseText);
            }
            return ok(res);
          }
          return ok(this.handleRes('fail', this.xhr.status, this.xhr.responseText));
        }
      };
      this.xhr.onerror = (e) => {
        console.error(e);
        ok(this.handleRes('error', -1, null));
      };
    });
  }

  protected setHeaders() {
    this.parseHeaders();
    // eslint-disable-next-line no-restricted-syntax
    for (const key in this.headers) {
      const v = this.headers[key];
      if (v) {
        this.xhr.setRequestHeader(key, v);
      }
    }
  }

  private parseHeaders() {
    let defaultHeaders = {};
    if (this.config.method === 'POST') {
      defaultHeaders = {
        'Content-Type': 'application/json',
      };
    }
    this.headers = Object.assign(
      this.headers,
      defaultHeaders,
      this.config.headers
    );
  }
}

export default XHRProxy;
